import { render } from "./PrivacyPolicyCheckbox.vue?vue&type=template&id=06a61867&scoped=true"
import script from "./PrivacyPolicyCheckbox.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyCheckbox.vue?vue&type=script&lang=js"

import "./PrivacyPolicyCheckbox.vue?vue&type=style&index=0&id=06a61867&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a61867"]])

export default __exports__